import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ZmanimItem = styled.div`
  display: grid;
  grid-template-columns: 4fr 2fr;
  gap: 10px;
  padding: 4px 0;
  border-bottom: 1px solid rgba(45, 54, 83, 0.2);
  
  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    gap: 5px;
  }
`;

const ZmanimLabel = styled.div`
  color: #2D3653;
  font-family: 'IBM Plex Sans JP', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: clamp(14px, 1vw, 18px);
`;

const ZmanimValue = styled.div`
  color: #2D3653;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: clamp(14px, 1vw, 18px);
`;

const PanelTitle = styled.h2`
  color: #2D3653;
  text-align: center;
  font-family: 'Style Script', cursive;
  font-size: clamp(16px, 1.5vw, 24px);
  margin-bottom: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 0;
  }
`;

const ZmanimContainerLong = ({ zmanim }) => {
  const { t } = useTranslation();
  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
      <>
      <PanelTitle>{t('display.zmanim')}</PanelTitle>
        {zmanim?.zmanimFormatted && Object.entries(zmanim.zmanimFormatted).map(([key, value]) => (
          <ZmanimItem key={key}>
            <ZmanimLabel>
              {key.replace(/([A-Z])/g, ' $1')
                  .replace(/^./, str => str.toUpperCase())}
            </ZmanimLabel>
            <ZmanimValue>{formatTime(value)}</ZmanimValue>
          </ZmanimItem>
        ))}
      </>
  );
};

export default ZmanimContainerLong; 